import { useCurrentUser } from 'hooks/useCurrentUser'
import { useQuery } from 'hooks/useQuery'

import { fetchPosts, fetchPostsbyIds } from 'utils/queries'

import { Post } from 'types/post'

export const usePosts = ({ postIds }: { postIds: string[] }) => {
  return useQuery<Array<Post>>(['posts', ...postIds], () => fetchPostsbyIds({ postIds }))
}

export const useCurrentUserWorkouts = () => {
  const { data: currentUser } = useCurrentUser()
  return useQuery<Array<Post>>(
    ['currentUserWorkouts'],
    () =>
      fetchPosts(
        { creatorId: currentUser?.id, filter: 'Workouts' },
        { order: 'created', orderDirection: 'desc' },
      ),
    {
      enabled: currentUser?.id !== undefined,
    },
  )
}
